import DashboardPageLayout from "../../components/layout/DashboardPageLayout";
import HomePage from "../../pages/home/HomePage";
import HandymanIcon from "@mui/icons-material/Handyman";
import { RouteType } from "../config";
import ListagemOSPage from "../../pages/OrdemServico/ListaOS/ListagemOSPage";
import OSPage from "../../pages/OrdemServico/ListaOS/OSPage";
import ServicoPorUsuarioPage from "../../pages/OrdemServico/ListaOS/ServicoPorUsuarioPage";

const grupoOrdemServico: RouteType = {
  path: "/ordemServico",
  element: <DashboardPageLayout />,
  show: true,
  state: "ordemServico",
  sidebarProps: {
    displayText: "Ordem servico",
    icon: <HandymanIcon />,
  },

  child: [
    {
      index: true,
      element: <HomePage />,
      state: "ordemServico.index",
      show: true,
    },

    {
      path: "/ordemServico/cadastro/:osId",
      element: <OSPage />,
      state: "ordemServico.cadastro",
      show: true,
      verificarPermissao: () => false,
      sidebarProps: {
        displayText: "Nova ordem de serviço",
      },
    },

    {
      path: "/ordemServico/listagem",
      element: <ListagemOSPage />,
      state: "ordemServico.listagemPorResposavel",
      show: true,
      sidebarProps: {
        displayText: "Lista de OS",
      },
    },
    {
      path: "/ordemServico/listagemPorResponsavel",
      element: <ServicoPorUsuarioPage />,
      state: "ordemServico.listagem",
      show: true,
      sidebarProps: {
        displayText: "Meus serviços",
      },
    },
  ],
};

export default grupoOrdemServico;
